import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { InfoOutlined } from "@mui-symbols-material/w300"
import React from "react"

interface TableCellWithIdProps {
  children: React.ReactNode
  id?: string | number | null
}

const TableCellWithId: React.FC<TableCellWithIdProps> = ({ children, id }) => (
  <Box className='flex items-center'>
    <Typography fontSize='14px'>{children}</Typography>
    {id && (
      <Tooltip title={`AS400 ID ${id}`} placement='top'>
        <IconButton size='small' className='ml-1'>
          <InfoOutlined fontSize='small' />
        </IconButton>
      </Tooltip>
    )}
  </Box>
)

export default TableCellWithId
